import { AuthGuard } from '../../shared/services';
import { CagnottesDetailsRoutes } from './cagnottes-details/cagnottes-details.routes';
import { CagnottesListRoutes } from './cagnottes-list/cagnottes-list.routes';
import { CagnottesViewRoutes } from './cagnottes-view/cagnottes-view.routes';
import { CagnottesComponent } from './cagnottes.component';
import { Route } from '@angular/router';

export const CagnottesRoutes: Route[] = [
  {
    path: 'cagnottes',
    component: CagnottesComponent,
    canActivate: [AuthGuard],
    children: [
      ...CagnottesListRoutes,
      ...CagnottesDetailsRoutes,
      ...CagnottesViewRoutes
    ]
  }
];
